import { render } from "./mispadres.vue?vue&type=template&id=cbc8971a&scoped=true"
import script from "./mispadres.vue?vue&type=script&lang=js"
export * from "./mispadres.vue?vue&type=script&lang=js"

import "./mispadres.vue?vue&type=style&index=0&id=cbc8971a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc8971a"]])

export default __exports__